import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import { StyledImageButtonProps } from '../../constants/interfaces';

const ImageButton = styled(ButtonBase)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  height: 'auto',
  overflow: 'hidden',
  borderRadius: '8px',
  '&:hover img': {
    transform: 'scale(0.95)',
  },
  [theme.breakpoints.down('sm')]: {
    width: '100% !important', // Overrides inline-style
    height: 'auto',
  },
  '&:hover, &.Mui-focusVisible': {
    zIndex: 1,
    '& .MuiImageBackdrop-root': {
      opacity: 0.4,
    },
    '& .MuiImageMarked-root': {
      opacity: 1,
    },
    '& .MuiTypography-root': {
      // border: '4px solid currentColor',
    },
  },
}));

const Image = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.common.white,
}));

const ImageBackdrop = styled('span')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  backgroundColor: theme.palette.common.black,
  opacity: 0.1,
  transition: theme.transitions.create('opacity'),
}));

const ImageMarked = styled('span')(({ theme }) => ({
  height: 3,
  width: 18,
  backgroundColor: theme.palette.common.black,
  position: 'absolute',
  bottom: -2,
  left: 'calc(50% - 9px)',
  opacity: 0,
  transition: theme.transitions.create('opacity'),
}));

export default function StyledImageButton(props: StyledImageButtonProps) {
  const { url, title, onClick } = props
  return (
    < >
        <ImageButton
          focusRipple
          key={title}
          onClick={onClick}
        >
          {/* <ImageSrc style={{ backgroundImage: `url(${url})` }} /> */}
          <img style={{transform: 'translate(-30%, -20%) scaleX(-1) scale(1.6)'}} src={url} alt={title} width={'100%'}/>
          {/* <ImageBackdrop className="MuiImageBackdrop-root" /> */}
          <Image>
            <Typography
              component="span"
              variant="h3"
              sx={[
                {
                  // textShadow: '1px 1px 1px rgba(0, 0, 0, 1);',
                },
                (theme) => ({
                  color: theme.palette.text.primary,
                  position: 'relative',
                  left: '5%',
                  top: '30%',
                  p: 0.4,
                  pt: 1.5,
                  pb: `calc(${theme.spacing(0.5)} + 6px)`,
                }),
              ]}
            >
              {title}
              <ImageMarked className="MuiImageMarked-root" />
            </Typography>
          </Image>
        </ImageButton>
    </>
  );
}